import styled from 'styled-components';
import Container from '@material-ui/core/Container';

export const ShippingWrapper = styled(Container)`
    background-color: rgba(255,255,255, 0.35);
    color: rgb(239, 255, 250, 0.8);
    font-size: 180%;
    border-radius: 15px;
    padding: 10px;
`